import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TripService } from 'src/app/services/core/trip/trip.service';

@UntilDestroy()

@Component({
  selector: 'app-trip-trails-modal',
  templateUrl: './trip-trails-modal.component.html',
  styleUrls: ['./trip-trails-modal.component.css']
})
export class TripTrailsModalComponent implements OnInit {
  @Output() closeModal = new EventEmitter<any>
  @Input() tripId: any;
  @Input() source?: any;
  @ViewChild('map') map!: GoogleMap;
  events: any = [];
  polylinePath: any[] = [];

  constructor(
    private tripService: TripService
  ) {
  }

  ngOnInit(): void {
    this.getTripEvents();
  }

  ngAfterViewInit(): void {
    this.fitMapToBounds();
  }

  getSortedBreakdown(breakdown: any) {
    if (!breakdown) return [];

    const priority: Record<string, number> = {
      total: 0,
      baseFare: 1,
    };
    return Object.entries(breakdown)
      .sort(([keyA], [keyB]) => {
        const orderA = keyA in priority ? priority[keyA] : 2;
        const orderB = keyB in priority ? priority[keyB] : 2;
        return orderA - orderB;
      })
      .map(([key, value]) => ({
        key: this.formatKey(key),
        value
      }));
  }
  private formatKey(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, char => char.toUpperCase());
  }


  getTripEvents() {
    const queryParams: any = this.source === 'billing' ? { billing: this.tripId } : { trip: this.tripId };
    this.tripService.getPickerTripEvents(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data.results) {
          this.events = data.results;
          console.log('Trip Events:', this.events);
          this.polylinePath = this.events.map((e: any) => ({
            lat: e.latitude,
            lng: e.longitude
          }));
          this.fitMapToBounds();
        }
      });
  }

  fitMapToBounds() {
    if (!this.events.length || !this.map || !this.map.googleMap) return;

    const bounds = new google.maps.LatLngBounds();
    this.events.forEach((e: any) => {
      bounds.extend(new google.maps.LatLng(e.latitude, e.longitude));
    });

    const gMap = this.map.googleMap;
    if (!gMap) return;

    gMap.fitBounds(bounds, 8);
    const mzoom: any = gMap.getZoom();
    gMap.setZoom(mzoom);
  }

  getMarkerLabel(index: number): string {
    if (index === 0) return 'S';
    if (index === this.events.length - 1) return 'E';
    return index.toString();
  }
  onCloseModal() {
    this.closeModal.emit();
  }

}
